<script>
  export let name = ""

  export let value
</script>

<select name={name} bind:value={value} {...$$restProps}>
  <slot />
</select>

<style>
  select {
    flex-grow: 1;
    font-size: 1rem;
    padding: 0.4rem;
    outline: none;
    border-radius: 5px;
    border: 1px solid lightgrey;
    background-color: white;
  }

  select:focus {
    outline: 2px solid #006bdf;
    outline-offset: -1px;
  }
</style>
